import React from 'react'
import { AdvancedFilter } from 'components/Filter/AdvancedFilter'
import { DecreaseOriginalValueMain } from './DecreaseOriginalValueMain'
import { DecreaseOriginalValueForm } from './DecreaseOriginalValueForm/DecreaseOriginalValueForm'

const decreaseOriginalValueRoutes = [
  /* -------------------------------------------- */
  /*                ADVANCED FILTER               */
  /* -------------------------------------------- */
  {
    props: {
      exact: true,
      path:
        '/fixed-assets/:CompanyID/assets-change/decrease-original-value/filter',
    },
    component: (
      <AdvancedFilter
        mode="assets-change"
        app="fixed-assets"
        hasStatus
        hasDocDate
        hasDateRange
      />
    ),
  },

  /* -------------------------------------------- */
  /*                     MAIN                     */
  /* -------------------------------------------- */
  {
    props: {
      exact: true,
      path: '/fixed-assets/:CompanyID/assets-change/decrease-original-value',
    },
    component: <DecreaseOriginalValueMain />,
  },

  /* -------------------------------------------- */
  /*                     FORM                     */
  /* -------------------------------------------- */

  {
    props: {
      exact: true,
      path:
        '/fixed-assets/:CompanyID/assets-change/decrease-original-value/add',
    },
    component: (
      <DecreaseOriginalValueForm formMode="add" type="ASSETS_REGISTRATION" />
    ),
  },
]

export default decreaseOriginalValueRoutes
